// import swal from 'sweetalert2'
import Vue from 'vue'
// import $ from 'jquery'
import axios from 'axios'

const LoginApi = {
  data: {
    urlLogo: './../../assets/Logo.png',
    // urlLogin: '/v2/participantLogin',
    urlLogin: '/api/v2/participant/login',
    urlReLogin: '/api/v2/participant/relogin',
    urlRgister: '/v1/register'
  },
  reLogin (group, fnSuccess, fnError) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    let url = Vue.prototype.$config.HOST_ONLINE + this.data.urlReLogin
    let params = {}
    Vue.prototype.$api.getCredentials().authToken = group.user.AuthToken
    let postData = {
      idKlausur: group.id,
      time: new Date().getTime(),
      pid: group.user.ID_Teilnehmer,
      token: Vue.prototype.$api.getCredentials().authToken
    }
    axios({
      method: 'post',
      url: url,
      params: params,
      data: postData
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (!response.data.success) {
          Vue.credentials = {
            'authorized': false,
            'authToken': '',
            'user': '',
            'data': response.data
          }
          cmp.onLoginFailed(response.data)
          if (fnError) {
            fnError(response.data)
          }
        } else {
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        }
      })
      .catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  doLogin (postData, fnSuccess, fnError) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    let url = Vue.prototype.$config.HOST_ONLINE + this.data.urlLogin
    let params = {}
    axios({
      method: 'post',
      url: url,
      params: params,
      data: postData
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (!response.data.success) {
          Vue.credentials = {
            'authorized': false,
            'authToken': '',
            'user': '',
            'data': response.data
          }
          cmp.onLoginFailed(response.data)
          if (fnError) {
            try {
              fnError(response.data)
            } catch (eee) {
              console.error(eee)
            }
          }
        } else {
          if (fnSuccess) {
            try {
              fnSuccess(response.data)
            } catch (eee) {
              console.error(eee)
            }
          }
        }
      })
      .catch(error => {
        console.log(error)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          if (error.response) {
            fnError(error.response)
          } else {
            fnError(error)
          }
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  onLoginFailed (data) {
    Vue.prototype.$api.credentials = null
    Vue.prototype.$api.setCredentials()
  },
  onLoginOk (data) {
    var credits = {
      'authorized': true,
      'authToken': data.authToken,
      'user': data.username,
      'data': data
    }
    Vue.prototype.$api.credentials = credits
    Vue.prototype.$api.setCredentials()
    Vue.prototype.$apiParticipant.setParticipantData(data.groupList, data.questions)
    Vue.prototype.$api.getJQuery().ajaxSetup({
      headers: {
        'X-Auth-Token': data.authToken
      }
    })
    if (window.jQuery) {
      window.jQuery.ajaxSetup({
        headers: {
          'X-Auth-Token': data.authToken
        }
      })
    }
  }
}
export default LoginApi



// WEBPACK FOOTER //
// ./src/components/loginParticipant/Login.js